var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 16.25C3.40278 16.25 3.10778 16.1283 2.865 15.885C2.62167 15.6422 2.5 15.3472 2.5 15C2.5 14.6528 2.62167 14.3578 2.865 14.115C3.10778 13.8717 3.40278 13.75 3.75 13.75C4.09722 13.75 4.39222 13.8717 4.635 14.115C4.87833 14.3578 5 14.6528 5 15C5 15.3472 4.87833 15.6422 4.635 15.885C4.39222 16.1283 4.09722 16.25 3.75 16.25ZM6.66667 15.8333V14.1667H17.5V15.8333H6.66667ZM3.75 11.25C3.40278 11.25 3.10778 11.1283 2.865 10.885C2.62167 10.6422 2.5 10.3472 2.5 10C2.5 9.65278 2.62167 9.35778 2.865 9.115C3.10778 8.87167 3.40278 8.75 3.75 8.75C4.09722 8.75 4.39222 8.87167 4.635 9.115C4.87833 9.35778 5 9.65278 5 10C5 10.3472 4.87833 10.6422 4.635 10.885C4.39222 11.1283 4.09722 11.25 3.75 11.25ZM6.66667 10.8333V9.16667H17.5V10.8333H6.66667ZM3.75 6.25C3.40278 6.25 3.10778 6.12833 2.865 5.885C2.62167 5.64222 2.5 5.34722 2.5 5C2.5 4.65278 2.62167 4.35778 2.865 4.115C3.10778 3.87167 3.40278 3.75 3.75 3.75C4.09722 3.75 4.39222 3.87167 4.635 4.115C4.87833 4.35778 5 4.65278 5 5C5 5.34722 4.87833 5.64222 4.635 5.885C4.39222 6.12833 4.09722 6.25 3.75 6.25ZM6.66667 5.83333V4.16667H17.5V5.83333H6.66667Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.ed6bbd3ce66b75b7ea67f35b1ae9aa98.svg";
export { ForwardRef as ReactComponent };